export const filterProduction = productions => {
    const productionYears = productions.map(({productionYear}) => productionYear);
    const filteredYears = productionYears.filter((year, index) => productionYears.indexOf(year) === index);
    
    const yearsArray = filteredYears.map(year => {
        return productions.filter(item => item.productionYear === year);
    })

    return yearsArray;
}